module.exports = __webpack_public_path__ + "ecosystem_logo.dc2f1a97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/ecosystem_logo.png
// module id = 361
// module chunks = 0